import React, { useState } from "react";
import { StyleSheet, css } from "aphrodite";
import plusIcon from "./../assets/plus.png";
import minusIcon from "./../assets/minus.png";
import checkIcon from "./../assets/check.png";
import warningIcon from "./../assets/warning.png";
import cancelIcon from "./../assets/cancel.png";
import SolutionField from "./SolutionField";

const styles = StyleSheet.create({
  header: {
    padding: "10px",
    borderBottom: "1px solid black",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: "20px",
    paddingLeft: "20px",
  },
  headerBtn: {
    width: "30px",
    height: "30px",
    border: "none",
  },
  headerBtnImg: {
    width: "30px",
    height: "30px",
  },
  criticalAlert: {
    padding: "10px",
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid black",
  },
  criticalAlertImg: {
    width: "50px",
    height: "50px",
    marginRight: "20px",
  },
  criticalAlertHeading: {
    color: "red",
    fontWeight: "700",
    fontSize: "20px",
  },
  logTable: {
    width: "100%",
  },
  logTR: {
    borderBottom: "1px solid black",
    ":last-child": {
      borderBottom: "none",
    },
  },
  toggleBtn: {
    border: "none",
  },
  toggleBtnImg: {
    width: "20px",
    height: "20px",
  },
  symbolImg: {
    width: "30px",
    height: "30px",
    margin: "0 auto",
  },
  solutionLiItem: {
    listStyle: "none",
  },
});

const NAME_REGISTRY = {
  FILE_TYPE: "File type",
  FILE_COMPLIANCE: "Compliant file",
  MISSING_LABELS: "Missing labels",
  EMPTY_ROWS: "Empty rows",
  MULTI_LABELS: "Multi-answer labels",
  AMBIGUOUS_LABELS: "Ambiguous labels",
  NO_ID_COLUMN: "No ID column",
  AMBIGUOUS_ID_COLUMN: "Ambiguous ID column",
  SKIPPED_COLUMNS: "Skipped columns",
  TOO_FEW_OPEN_ANSWERS: "Min number of open answers",
  SKIPPED_OPEN_QUESTIONS: "Skipped open questions",
  CLOSED_QUESTION_AMT: "Number of closed questions",
  INTERVIEW_MAX: "Max number of interviews",
  INTERVIEW_MIN: "Min number of interviews",
  UNIQUE_QUESTIONS: "Unique questions",
  CLUSTER_ANALYSIS_OUTCOME: "Cluster analysis",
};

const LogReport = ({ logData, hasCritical }) => {
  const [detailsShown, setDetailShown] = useState([]);

  const toggleShown = (keyStr) => {
    const shownState = detailsShown.slice();
    const index = shownState.indexOf(keyStr);
    if (index >= 0) {
      shownState.splice(index, 1);
      setDetailShown(shownState);
    } else {
      shownState.push(keyStr);
      setDetailShown(shownState);
    }
  };

  const RowItem = ({ item, keyVal }) => {
    return (
      <tr className={css(styles.logTR)} key={"TR:" + keyVal}>
        <td width="5%">
          {item.kind.toLowerCase() !== "success" && (
            <button
              onClick={() => toggleShown("TR:" + keyVal)}
              className={css(styles.toggleBtn)}
            >
              <img
                src={
                  detailsShown.includes("TR:" + keyVal) ? minusIcon : plusIcon
                }
                className={css(styles.toggleBtnImg)}
              />
            </button>
          )}
        </td>
        <td width="10%">
          {item.kind.toLowerCase() === "success" && (
            <img src={checkIcon} className={css(styles.symbolImg)} />
          )}
          {item.kind.toLowerCase() === "warning" && (
            <img src={warningIcon} className={css(styles.symbolImg)} />
          )}
          {item.kind.toLowerCase() === "error" && (
            <img src={cancelIcon} className={css(styles.symbolImg)} />
          )}
        </td>
        <td width="20%">{NAME_REGISTRY[item.id]}</td>
        <td width="10%">
          {item.kind.toLowerCase() === "success" && (
            <span style={{ color: "#009c00" }}> {item.kind} </span>
          )}
          {item.kind.toLowerCase() === "warning" && (
            <span style={{ color: "#FF6400" }}> {item.kind} </span>
          )}
          {item.kind.toLowerCase() === "error" && (
            <span style={{ color: "red" }}> {item.kind} </span>
          )}
        </td>
        <td width="50%">
          <SolutionField
            messageId={item.id}
            kind={item.kind}
            extra_data={item.extra_data}
            showDetail={detailsShown.includes("TR:" + keyVal)}
          />
        </td>
      </tr>
    );
  };
  return (
    <div>
      <div className={css(styles.box)}>
        {hasCritical && (
          <div className={css(styles.criticalAlert)}>
            <div>
              <img src={cancelIcon} className={css(styles.criticalAlertImg)} />
            </div>
            <div>
              <h3 className={css(styles.criticalAlertHeading)}>
                CRITICAL ISSUES DETECTED IN YOUR SURVEY DATA.
              </h3>
              <p>
                Read how to fix all issues in the test report below and run
                LogRatio again. If you still can’t analyze your survey data,
                contact us and we will help you.
              </p>
            </div>
          </div>
        )}
        <div style={{ padding: "10px", paddingBottom: "30px" }}>
          <table className={css(styles.logTable)}>
            <thead>
              <tr>
                <th></th>
                <th>SYMBOL</th>
                <th>TEST NAME</th>
                <th>RESULTS</th>
                <th>SOLUTION</th>
              </tr>
            </thead>
            <tbody>
              {logData.map((item, key) => {
                return <RowItem key={key} item={item} keyVal={key} />;
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LogReport;
